import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useNetwork } from '@vueuse/core';

/** Path prefixes for asset routes - returning from these to Search should keep results */
const ASSET_PATH_PREFIXES = ['/video', '/videoTest', '/show/', '/series/', '/movie/', '/subscribeGuide'];

export interface SearchCachedState {
  searchQuery: string;
  matchGroupInfo: any[];
  textResults: string[];
  searchData: any;
}

export const useCommonStore = defineStore('common', () => {
  const { isOnline, downlink, effectiveType } = useNetwork();
  const loaded = ref(false);
  /** When true, Search page should preserve results on activation (e.g. back from asset page) */
  const searchShouldKeepResults = ref(false);
  /** Cached search state - used when returning from Video (no keepAlive) which remounts Search */
  const searchCachedState = ref<SearchCachedState | null>(null);

  function setLoaded(value: boolean) {
    loaded.value = value;
  }

  function setSearchShouldKeepResults(value: boolean) {
    searchShouldKeepResults.value = value;
  }

  function setSearchCachedState(state: SearchCachedState | null) {
    searchCachedState.value = state;
  }

  function isAssetRoute(route: { path?: string; name?: string | symbol }): boolean {
    const path = route?.path || '';
    return ASSET_PATH_PREFIXES.some(prefix => path.startsWith(prefix));
  }

  return {
    isOnline,
    downlink,
    effectiveType,
    loaded,
    setLoaded,
    searchShouldKeepResults,
    setSearchShouldKeepResults,
    searchCachedState,
    setSearchCachedState,
    isAssetRoute,
  };
});
